import { axios } from '@/plugins/axios-pol'

const BASE_PATH = '/personal/api/EstadoFuerza'

/**
 * Obtiene el personal de una dependencia dada desde la API. (aka personal lite)
 *
 * Realiza una petición GET a `${BASE_PATH}/dependencias/{idDependencia}/personal`
 * y devuelve el payload parseado de la respuesta. La API puede devolver el
 * payload como una cadena JSON dentro del campo `data`, por lo que esta función
 * detecta ese caso y la parsea antes de devolverlo.
 *
 * @param {string|number} idDependencia - Identificador de la dependencia cuya plantilla se solicita.
 * @returns {Promise<any>} Resuelve con el contenido parseado del campo `data` de la respuesta.
 * @throws {Error} Propaga errores de red o de parseo (por ejemplo JSON inválido).
 */
async function fetchPersonalByDependencia(idDependencia) {
  const response = await axios.get(`${BASE_PATH}/dependencias/${idDependencia}/personal`)

  const { data } = response.data

  return typeof data === 'string' ? JSON.parse(data) : data
}

export default function createPersonalApiRepository() {
  return {
    fetchPersonalByDependencia,
  }
}
